import {appStates} from '../constants/appStates';

const STORAGE_KEY = 'ut_dev_ui_mock';

/**
 * Development-only: bypass publisher + permissions gating so the shell (sidebar,
 * dashboard, etc.) renders without backend publisher /features APIs.
 *
 * Enable once:
 *   localStorage.setItem('ut_dev_ui_mock', '1')
 * or open the app with ?ut_dev_ui_mock=1 (also persists the flag).
 *
 * Disable:
 *   localStorage.removeItem('ut_dev_ui_mock')
 *
 * Note: URLs like #/0/dashboard use publisher id 0, which the app treats as
 * “no id”, so getCurrentPublisher never runs. This mock maps invalid/zero ids
 * to publisher 1 while the flag is on.
 */
export function isDevUiMockEnabled() {
    if (process.env.NODE_ENV === 'production') {
        return false;
    }
    if (typeof window === 'undefined') {
        return false;
    }
    try {
        const q = new URLSearchParams(window.location.search);
        if (q.get('ut_dev_ui_mock') === '2002') {
            window.localStorage.setItem(STORAGE_KEY, '2002');
        }
        return window.localStorage.getItem(STORAGE_KEY) === '2002';
    } catch (e) {
        return false;
    }
}

export function parseDevUiMockPublisherId() {
    const h = (typeof window !== 'undefined' && window.location.hash) || '';
    const path = h.replace(/^#\/?/, '');
    const first = path.split('/').filter(Boolean)[0];
    const n = parseInt(first, 10);
    if (Number.isNaN(n) || n < 1) {
        return 1;
    }
    return n;
}

export function getDevUiMockPublisher(publisherId) {
    return {
        data: {
            id: publisherId,
            publisherTypeId: 1,
            country: 'US',
            name: `Dev mock publisher (${publisherId})`
        },
        state: appStates.LOADED
    };
}

/** Same paths as routes.js — all enabled without calling ut-permissions-module. */
export function applyDevUiRouteOverrides(localRoutes) {
    return localRoutes.map((r) => ({...r, isEnabled: true}));
}
